const WasteFlowFormChevron = ({ className = "" }) => (
  <svg
    className={`h-4 w-4 shrink-0 text-[#222222] ${className}`.trim()}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);

export default WasteFlowFormChevron;
